module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-mobile@2x-2ee3350b2e3e34906b4180210f043d92.jpg";